import { $authHost, $host } from "./index";
import { jwtDecode } from "jwt-decode";

const getTokenUserId = () => {
    try {
        const token = localStorage.getItem("token");
        return token ? Number(jwtDecode(token)?.id) : null;
    } catch (_) {
        return null;
    }
};

const scopedPath = (basePath, userId) => {
    const tokenUserId = getTokenUserId();
    return tokenUserId && Number(userId) === tokenUserId
        ? `${basePath}/me`
        : `${basePath}/${userId}`;
};

const scopedBookAssPath = (userId, type, id) => {
    const tokenUserId = getTokenUserId();
    const userSegment = tokenUserId && Number(userId) === tokenUserId ? "me" : userId;
    return `book-ass-logs/${userSegment}/${type}/${id}`;
};

export const fetchUnreadCount = async (userId) => {
    const { data } = await $authHost.get(`api/userlogs/${scopedPath("unread", userId)}`);
    return data.unreadCount;
};

export const fetchFinUnreadCount = async (userId) => {
    const { data } = await $authHost.get(`api/userlogs/${scopedPath("fin_unread", userId)}`);
    return data.unreadCount;
};

export const fetchUserLogs = async (userId, options = 700) => {
    const params = typeof options === "object" && options !== null
        ? options
        : { limit: options };
    const { data } = await $authHost.get(`api/userlogs/${scopedPath("logs", userId)}`, {
        params,
    });
    return data;
};

export const fetchUserLogsBA = async (userId, type, id, limit = 500) => {
    const { data } = await $authHost.get(`api/userlogs/${scopedBookAssPath(userId, type, id)}`, {
        params: { limit },
    });
    return data;
};

export const fetchUserFinLogs = async (userId, options = {}) => {
    const params = typeof options === "object" && options !== null
        ? options
        : {};
    const { data } = await $authHost.get(`api/userlogs/${scopedPath("fin_logs", userId)}`, {
        params,
    });
    return data;
};

export const fetchAffiliateLogs = async (userId, filters = {}) => {
    const { data } = await $authHost.get(`api/userlogs/${scopedPath("affiliate-logs-tree", userId)}`, {
        params: filters,
    });
    return data;
};

export const markLogsAsRead = async (_userId, logId) => {
    const ids = logId ? [logId] : undefined;
    const { data } = await $authHost.post("api/userlogs/mark-read", { ids });
    return data;
};

export const markFinLogsAsRead = async (_userId, logId) => {
    const ids = logId ? [logId] : undefined;
    const { data } = await $authHost.post("api/userlogs/fin_mark-read", { ids });
    return data;
};

export const addUserFinLog = async (
    user_id, userId, user_name, user_amz_name,
    subtotal_amount, total_amount, description,
    log_type, referrer_id,
) => {
    const { data } = await $authHost.post("api/userlogs/fin_add", {
        user_id, userId, user_name, user_amz_name,
        subtotal_amount, total_amount, description,
        log_type, referrer_id,
    });
    return data;
};

export const fetchAssignLogs = async (assignId) => {
    const { data } = await $authHost.get(`api/userlogs/assign-logs/${assignId}`);
    return data;
};

export const addUserLog = async (
    userId,
    amount,
    balance_state,
    logType,
    description,
    user_trust_level,
    user_amz_name,
    user_audible_name,
    user_email,
    user_log,
    user_log_date,
    description_no_currency,
    assignmentId,
    assTypeId,
    booksTypeId,
    booksPriceId,
    booksLanguageId,
    booksGenreId,
    bookId,
    poolId,
    poolItemId,
) => {
    const { data } = await $authHost.post("api/userlogs/add", {
        userId,
        amount,
        balance_state,
        logType,
        description,
        user_trust_level,
        user_amz_name,
        user_audible_name,
        user_email,
        user_log,
        user_log_date,
        description_no_currency,
        assignmentId,
        assTypeId,
        booksTypeId,
        booksPriceId,
        booksLanguageId,
        booksGenreId,
        bookId,
        poolId,
        poolItemId,
    });
    return data;
};

export const fetchUserFinanceHistory = async (userId) => {
    try {
        const { data } = await $authHost.get(`/api/userlogs/${scopedPath("finance-history", userId)}`);
        return data;
    } catch (error) {
        console.error("Error fetching finance history:", error);
        return [];
    }
};

export const fetchUserFinanceHistory3 = async (userId) => {
    try {
        const { data } = await $authHost.get(`/api/userlogs/${scopedPath("finance-history-3", userId)}`);
        return data;
    } catch (error) {
        console.error("Error fetching finance history:", error);
        return [];
    }
};

export const fetchAdminFinanceHistory = async () => {
    try {
        const { data } = await $authHost.get("/api/userlogs/finance-history-summary");
        return data;
    } catch (error) {
        console.error("Error fetching finance history:", error);
        return [];
    }
};

export const getAdminSystemHistory = async () => {
    try {
        const { data } = await $authHost.get("/api/userlogs/get-system-summary");
        return data;
    } catch (error) {
        console.error("Error fetching system history:", error);
        return [];
    }
};

export const collectVisitLogPublic = async (payload) => {
    const { data } = await $host.post("api/userlogs/collect", payload);
    return data;
};

export const fetchuserlogsByUser = async (userId, params = {}) => {
    const { data } = await $authHost.get(`api/userlogs/${scopedPath("user", userId)}`, {
        params,
    });
    return data;
};

export const fetchRecentVisitLogs = async (params = {}) => {
    const { data } = await $authHost.get("api/userlogs/get-recent-activity-dashboard", {
        params,
    });
    return data;
};

export const getDashboardActivityApi = async (params = {}) => {
    const { data } = await $authHost.get("/api/userlogs/get-recent-activity-dashboard", {
        params,
    });
    return data;
};

export const getLinkedByUserApi = async (userId, params = {}) => {
    const { data } = await $authHost.get(`/api/userlogs/${scopedPath("linked", userId)}`, {
        params,
    });
    return data;
};

export const fetchUserLogsAdmin = async (params = {}) => {
    try {
        const {
            page = 1,
            limit = 50,
            q,
            user_id,
            log_type,
        } = params;

        const query = new URLSearchParams();
        if (page) query.set("page", String(page));
        if (limit) query.set("limit", String(limit));
        if (q && String(q).trim()) query.set("q", String(q).trim());
        if (user_id && String(user_id).trim()) query.set("user_id", String(user_id).trim());
        if (log_type && String(log_type).trim()) query.set("log_type", String(log_type).trim());

        const { data } = await $authHost.get(`api/userlogs/all-logs-adm_search?${query.toString()}`);
        return data;
    } catch (error) {
        console.error("Error fetching logs:", error);
        throw new Error(error?.response?.data?.message || "Failed to fetch user logs");
    }
};
